import { Transform } from 'class-transformer';

export function UndefinedToNull() {
  return Transform(({ value }) => {
    if (value === undefined) {
      return null;
    }

    return value;
  });
}

export function UniqueArray(): PropertyDecorator {
  return Transform(({ value }) => {
    if (Array.isArray(value)) {
      return Array.from(new Set(value));
    }
    return value;
  });
}
